var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { UsuarioService } from '../../services/usuario.service';
import { ServiceException } from '../../model/exception';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { AutoCompleteConfig } from '../../common/autocomplete/autocomplete.config';
import { Organismo } from "../../model/organismo";
var DatosDemandaComponent = (function () {
    function DatosDemandaComponent(_usrService, _comService) {
        this._usrService = _usrService;
        this._comService = _comService;
        this.onComplete = new EventEmitter(false);
        this.tex_cod = "";
        this.fuero = 0;
        this.tipo = 0;
        this.inst = 0;
        this.cir = 0;
        this.cir_descr = "";
        this.tex_cod_conexo = "";
        this.conexo = false;
        this.minCharsForSearch = 1;
        this.placeholder = 'Concepto'; //min amount of chars before autocomplete mayches results
        this.responseApiKey = 'id'; //a reference to the key for example api response [{"id":1,"name":"USA"}, {..}]
        this.responseApiText = 'desc'; //a reference to the text for example api response [{"id":1,"name":"USA"}, {..}]
        this.concep = { id: 0, cod: "", desc: "", fuero: "" };
        this.tex = { codigo: "", descr: "", forcar: "" };
        this.causa = { habil: false, concepto: this.concep, tex: this.tex, nivel: 0, monto: "", cir_id: 0, observaciones: "", cir_desc: "", instancia: 0, caratula: "" };
        this.visibleMsg = false;
        this.verAceptar = true;
        this.aceptoExp = true;
    }
    DatosDemandaComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.hideErrorMsg();
        this.hideErrorMsgConexo();
        this.autocomplete.onItemSelected.subscribe(function (event) { _this.onChangeSelectCon(_this.autocomplete.selectedItem); });
        this.autocomplete.onDelSelected.subscribe(function (event) { _this.onDelSelectCon(_this.autocomplete.query); });
        this.autocompleteConfigAPISource = new AutoCompleteConfig(this.conceptoList, this.minCharsForSearch, this.placeholder, this.responseApiKey, this.responseApiText);
        this._comService.emitBlocking(true);
        //console.log("find concepto " + this.cir);
        this._comService.findConceptos(this.tex_cod, this.fuero, this.tipo, this.inst, this.cir).subscribe(function (response) {
            _this.conceptoList = response;
            _this.autocomplete.setDataSource(_this.conceptoList);
            _this.validateAllLoad();
        }, function (error) {
            _this._comService.emitBlocking(false);
            var exc = ServiceException.parse(error.json());
            //console.log(exc.toString());
            alert(exc.description);
            // that._comService.emitBlocking(false);
        });
        this._comService.findNivel().subscribe(function (response) {
            _this.caracterList = response;
            _this.validateAllLoad();
        });
        this.validateTipoExp();
    };
    DatosDemandaComponent.prototype.validateTipoExp = function () {
        if (this.conexo) {
            this.verAceptar = true;
            this.MsgTipos = "Ha elegido crear un tipo de expediente " + this.tex_cod.toUpperCase() + " en el " + this.organismo.descripcion.toUpperCase() + " de " + this.cir_descr.toUpperCase() + ", desea continuar? De caso contrario, vuelva a comenzar.";
            this.visibleMsg = true;
            this.aceptoExp = false;
        }
        this.validateData();
    };
    DatosDemandaComponent.prototype.onClickOK = function () {
        if (this.tex_cod === 'EXP' && this.conexo) {
            this.visibleMsg = false;
            this.aceptoExp = true;
            this.validateData();
        }
    };
    DatosDemandaComponent.prototype.setTwoNumberDecimal = function () {
        this.hideErrorMsg();
        //console.log("format " + this.causa.monto);
        if (this.causa.monto !== "") {
            var pattern = /[-+]?[0-9]*\.?[0-9]+([eE][-+]?[0-9]+)?/; //pattern notación cientifica
            //console.log("verifico que el monto no este en notacion cientifica");
            if (pattern.test(this.causa.monto)) {
                //console.log("verifico que no exceda el valor maximo");
                //console.log("valor "+ Number(this.causa.monto));
                //console.log("valor parsefloat "+ parseFloat(this.causa.monto));
                if (Number(this.causa.monto) > 999999999999) {
                    //console.log("monto mayor al permitido "+ Number(this.causa.monto));
                    this.causa.monto = "";
                    this.showErrorMessage("El Monto ingresado en inválido");
                    return false;
                }
            }
            this.causa.monto = parseFloat(this.causa.monto).toFixed(2);
        }
        //console.log("format salida " + this.causa.monto);
        //console.log("igual a NAN " + (this.causa.monto === "NaN"));
    };
    DatosDemandaComponent.prototype.hideErrorMsg = function () {
        //console.log("hide msg");
        this.ErrorMsg = "";
        this.ErrorMessageIsVisible = false;
    };
    DatosDemandaComponent.prototype.hideErrorMsgConexo = function () {
        //console.log("hide msg");
        this.MsgTipos = "";
        this.visibleMsg = false;
    };
    DatosDemandaComponent.prototype.showErrorMessage = function (msg) {
        //console.log("show error message");
        this.ErrorMsg = msg;
        this.ErrorMessageIsVisible = true;
    };
    DatosDemandaComponent.prototype.validateAllLoad = function () {
        if (JSON.stringify(this.conceptoList) !== "undefined" && JSON.stringify(this.caracterList) !== "undefined") {
            this._comService.emitBlocking(false);
        }
    };
    DatosDemandaComponent.prototype.onClickHabil = function (ev) {
        this.causa.habil = !this.causa.habil;
    };
    DatosDemandaComponent.prototype.onChangeSelectTipo = function (selected) {
        this.validateData();
    };
    DatosDemandaComponent.prototype.onChangeSelectCon = function (selected) {
        this.concep = this.conceptoList.find(function (item) { return item.id == selected.id; });
        this.causa.concepto = this.concep;
        this.causa.concepto.desc = this.causa.concepto.desc;
        this.validateData();
    };
    DatosDemandaComponent.prototype.onDelSelectCon = function (query) {
        this.causa.concepto = { id: 0, cod: "", desc: "", fuero: "" };
        this.validateData();
    };
    DatosDemandaComponent.prototype.validateData = function () {
        if (this.causa.monto === "" || this.causa.monto === "NaN" || this.causa.monto === null) {
            this.onComplete.emit(false);
            return;
        }
        if (this.causa.concepto.id == 0) {
            this.onComplete.emit(false);
            return;
        }
        if (this.causa.nivel == 0) {
            this.onComplete.emit(false);
            return;
        }
        this.onComplete.emit(true);
    };
    DatosDemandaComponent.prototype._keyPress = function (event) {
        this.hideErrorMsg();
        //const pattern =  /[/\-+E]/;
        //const pattern = /([0-9](\.\d))/;
        var pattern = /[.\-+]/;
        var inputChar = String.fromCharCode(event.charCode);
        //console.log("keypress " + event.charCode);
        if ((event.charCode != 0 && pattern.test(inputChar)) || event.charCode == 101) {
            event.preventDefault();
        }
        else {
            if (this.causa.monto === "" || this.causa.monto === "NaN") {
                this.causa.monto = event;
            }
            this.validateData();
        }
        document.getElementById("montoProceso").focus();
        //console.log("causa.monto " + this.causa.monto);
    };
    DatosDemandaComponent.prototype._keyUp = function (event) {
        this.hideErrorMsg();
        if (this.causa.monto === null) {
            this.validateData();
        }
        else {
            if (Number(this.causa.monto) > 999999999999) {
                var monto = String(this.causa.monto);
                var enteros = monto.substr(0, 12);
                var decimales = "";
                if (monto.indexOf(".") > 0) {
                    decimales = monto.substr(monto.indexOf("."), 3);
                }
                this.causa.monto = enteros + decimales;
            }
        }
    };
    return DatosDemandaComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], DatosDemandaComponent.prototype, "onComplete", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DatosDemandaComponent.prototype, "tex_cod", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosDemandaComponent.prototype, "fuero", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosDemandaComponent.prototype, "tipo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosDemandaComponent.prototype, "inst", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number)
], DatosDemandaComponent.prototype, "cir", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DatosDemandaComponent.prototype, "cir_descr", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], DatosDemandaComponent.prototype, "tex_cod_conexo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], DatosDemandaComponent.prototype, "conexo", void 0);
__decorate([
    Input(),
    __metadata("design:type", Organismo)
], DatosDemandaComponent.prototype, "organismo", void 0);
__decorate([
    ViewChild(AutocompleteComponent),
    __metadata("design:type", AutocompleteComponent)
], DatosDemandaComponent.prototype, "autocomplete", void 0);
DatosDemandaComponent = __decorate([
    Component({
        moduleId: module.id,
        selector: 'datos-demanda',
        templateUrl: 'datos-demanda.component.html',
    }),
    __metadata("design:paramtypes", [UsuarioService,
        CommonService])
], DatosDemandaComponent);
export { DatosDemandaComponent };
//# sourceMappingURL=datos-demanda.component.js.map